<ion-item class="form-element-wrapper" fill="outline" mode="md" lines="none">
  <ion-input
    label="Verification Code"
    labelPlacement="floating"
    [formControl]="ctrl"
    type="tel"
    pattern="[0-9]"
    autocomplete="one-time-code"
    required="'true'"
    mode="ios"
    (paste)="onPaste($event)"
    (input)="onInput($event)"
    (keydown.Backspace)="onBackspace($event)"
  ></ion-input>
</ion-item>

<ion-item *ngIf="invalid" lines="none" class="ion-padding-top">
  <ion-text color="danger"> Invalid code. Request a new code and try again. </ion-text>
</ion-item>

<ion-item lines="none" class="ion-padding-top">
  <ion-text color="medium" class="caption">
    MyOpinionMatters may use your phone number to call or send text messages with information regarding your account.
  </ion-text>
</ion-item>
